import React, { useEffect, useRef, useState } from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { Box, Divider, Typography } from '@mui/material';

interface GoogleAuthButtonProps {
  onSuccess: (idToken: string) => void;
}

const GOOGLE_BUTTON_MAX_WIDTH = 400;

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ onSuccess }) => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number>(GOOGLE_BUTTON_MAX_WIDTH);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;
    const update = () => {
      const w = Math.min(Math.floor(el.getBoundingClientRect().width), GOOGLE_BUTTON_MAX_WIDTH);
      if (w > 0) setButtonWidth(w);
    };
    update();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  if (!clientId) return null;

  const handleSuccess = (response: CredentialResponse) => {
    if (response.credential) {
      onSuccess(response.credential);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box ref={wrapperRef} sx={{ width: '100%', mb: 2 }}>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => { /* silent: user dismissed or popup blocked */ }}
          text="continue_with"
          shape="rectangular"
          theme="outline"
          size="large"
          width={buttonWidth}
        />
      </Box>
      <Divider sx={{ mb: 2 }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', px: 1 }}>o</Typography>
      </Divider>
    </Box>
  );
};
